// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatarDropdownUI__avatar___3PqwW","noti":"UserAvatarDropdownUI__noti___1gUrr","arrow":"UserAvatarDropdownUI__arrow___PAJXD"};